module.exports = __webpack_public_path__ + "img/智能门锁1.80091d31.png";